import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Button, Icon, Flex, Box, useMediaQuery } from '@spothero/ui';
import SpotListItemBase from 'common/spot-card-base/v2';
import FacilitySummary from 'common/facility-summary/v2';
import { push as pushTo } from 'store/router/router-actions';
import { showSpotsLeft } from 'utils/spot-left';
import { setSpotDetailReferrer as setSpotDetailReferrerTo, isExpressCheckoutEligible, } from 'store/spot/spot-actions';
import DynamicSpotListItemButton from '../spot-card-dynamic-CTA-button';
import { FACILITY_SUMMARY_VIEW_TYPES } from 'common/facility-summary/utils';
import { useDispatch, useSelector } from 'react-redux';
import useConfig from 'hooks/use-config';
import IconMarker from '@spothero/icons/pin-filled';
import { parseDistance } from 'utils/travel-distance';
import AirportCardTransportation from './AirportSpotTransportation';
import AirportSpotTag from './AirportSpotTag';
export const SpotListItemAirport = ({ spot, isActive, isHighlighted, isAdmin, isRebookingReservation, updateSelectedSpot, onShowDetailsClick, onBookSpotClick, referer = 'list', optimizely, }) => {
    const { isMobile } = useConfig();
    const dispatch = useDispatch();
    const { spotId, availability, facilityType, spotDetailsUrl, distance: { linearMeters }, transportation, tag, } = spot;
    const { available, availableSpaces } = availability;
    const containerClasses = classNames({ 'SpotListItem-active': isActive }, { 'SpotListItem-hovered': isHighlighted }, { unavailable: !available });
    const storeState = useSelector((state) => state);
    const { searchRequest, destination: { data: { airport: { iata_code: iataCode }, }, }, } = storeState;
    const handleShowDetailsClick = evt => {
        evt.preventDefault();
        evt.stopPropagation();
        setSpotDetailReferrerTo(referer);
        if (onShowDetailsClick) {
            onShowDetailsClick({ spotId });
        }
        if (isMobile) {
            dispatch(pushTo(spotDetailsUrl));
        }
        else {
            window.open(spotDetailsUrl, '_blank');
        }
        // Returning false from an anchor tag prevents the default behavior of following the href
        // In this instance, the href and this._url are for SEO purposes only
        return false;
    };
    const handleBookSpotClick = evt => {
        evt.preventDefault();
        evt.stopPropagation();
        const { selectedRate: { expressCheckoutUrl }, } = spot;
        const shouldSend = isExpressCheckoutEligible({
            spot,
            searchRequest,
            isRebookingReservation,
            isAdmin,
            eventPackage: null,
            optimizely,
        });
        if (onBookSpotClick) {
            onBookSpotClick({ spotId });
        }
        updateSelectedSpot({
            spot,
            referrer: referer,
            goToSpotUrl: true,
            optimizely,
        });
        const oldCheckoutUrl = spotDetailsUrl.replace('airport-parking', 'checkout');
        if (shouldSend) {
            window.location.href = expressCheckoutUrl;
        }
        else {
            pushTo(oldCheckoutUrl);
        }
    };
    const isShowSpotsLeftVisible = showSpotsLeft({
        available,
        availableSpaces,
        facilityType,
    });
    // @ts-expect-error - parseDistance function needs to be typed first
    const airportDistance = parseDistance({
        linearMeters,
        format: 'long',
    });
    const [isDeviceSmallerThan360px] = useMediaQuery('(max-width: 360px)');
    const showImages = useMemo(() => !isDeviceSmallerThan360px, [
        isDeviceSmallerThan360px,
    ]);
    return (<SpotListItemBase spotId={spotId} additionalClasses={containerClasses} onClick={handleShowDetailsClick} MainContent={<FacilitySummary 
        // @ts-ignore
        spot={spot} showImages={showImages} AirportTag={<AirportSpotTag tag={tag} title={spot.title} spotsLeft={isShowSpotsLeftVisible ? availableSpaces : null}/>} isAdmin={isAdmin} isShowSpotsLeftVisible={isShowSpotsLeftVisible} view={FACILITY_SUMMARY_VIEW_TYPES.SPOT_LIST} AirportDistance={<Flex alignItems="center" gap="0.5" mt="1">
                            <Icon as={IconMarker}/>
                            <Box data-testid="distance-destination">
                                {airportDistance} to {iataCode}
                            </Box>
                        </Flex>} AirportTransportationInfo={<AirportCardTransportation type={transportation?.type || ''}/>} CTAs={<>
                            <Button variant="tertiary" onClick={handleShowDetailsClick} display={!available ? 'none' : 'inline-flex'}>
                                Details
                            </Button>
                            <DynamicSpotListItemButton isAdmin={isAdmin} available={available} isRebookingReservation={isRebookingReservation} isHovered={isHighlighted} onClick={handleBookSpotClick}/>
                        </>}/>}/>);
};
export default React.memo(SpotListItemAirport);
